import "./TechScreen.css";

export default function TechScreen({ groups }) {
  return (
    <section className="section" id="tech">
      <div className="sectionHeader">
        <div className="sectionNum">05.</div>
        <div className="sectionTitle">Tech Stack</div>
      </div>

      <div className="techGrid">
        {groups.map((g) => (
          <div key={g.name} className="techCard">
            <div className="techName">
              <span>{g.name}</span>
            </div>

            <div className="pills">
              {g.items.map((x) => (
                <span key={x} className="pill">{x}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
